// AI Analyze — uses the buyer's Groq API key (from Settings) to analyze responses.
// The PWA works fully without this; the key is optional.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiAnalyzeResponses(
  serviceType: string,
  answers: Record<string, string>,
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a client success manager. Analyze these onboarding responses and suggest: 1) 3 missing questions to ask, 2) Recommended project scope, 3) Risk areas to address in contract, 4) Pricing strategy. Be specific and actionable. Use Markdown.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Service: ${serviceType}\n\nResponses: ${JSON.stringify(answers)}\n\nProvide analysis.` },
      ],
      temperature: 0.4,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
